<template>
  <div class="gap-md p-md max-w-content mx-auto flex flex-col">
    <div class="h-[32px]">
      <client-only>
        <GLink
          v-if="originInfo"
          :to="originInfo.url"
          data-role="button"
          data-style="text"
          class="self-start"
        >
          <template #prepend>
            <Icon name="fa6-solid:arrow-left" />
          </template>
          Revenir à {{ originInfo.label }}
        </GLink>
      </client-only>
    </div>

    <div class="gap-md flex flex-col">
      <h1 class="mb-xl text-center text-blue-500">Compte sans pub</h1>

      <span v-show="adlessEnd" class="text-large text-center font-semibold">
        Vous avez déjà un compte sans pub valable jusqu'au
        {{ useDateMedium(adlessEnd) }}
      </span>

      <span v-show="adlessEnd && adlessEnd >= inOneMonth" class="text-center"
        >Vous pourrez renouveler votre abonnement 1 mois avant la date
        d'expiration.</span
      >

      <span v-show="adlessEnd && adlessEnd < inOneMonth" class="text-center"
        >Vous pouvez dès maintenant renouveler votre abonnement.</span
      >

      <div class="flex justify-center">
        <div class="w-form flex flex-col">
          <div v-show="!adlessEnd" class="flex flex-col">
            <div class="mb-xl gap-xs flex flex-col">
              <p>
                Le fonctionnement de nos agendas dépend des revenus
                publicitaires.
              </p>
              <p>
                Nous avons conscience que ça peut parfois être gênant, c'est
                pourquoi nous vous proposons un compte sans publicité.
              </p>
            </div>

            <span class="mb-xl text-large font-bold"
              >Pourquoi prendre un compte sans pub ?</span
            >

            <div class="mb-lg flex justify-center">
              <div
                class="py-sm px-md gap-xs flex flex-col rounded-sm bg-orange-100"
              >
                <span class="gap-xs flex items-center">
                  <div class="flex size-5 items-center justify-center">
                    <Icon name="fa6-solid:bolt" class="text-large shrink-0" />
                  </div>
                  Navigation plus rapide, sans distraction
                </span>
                <span class="gap-xs flex items-center">
                  <div class="flex size-5 items-center justify-center">
                    <Icon
                      name="fa6-solid:euro-sign"
                      class="text-large shrink-0"
                    />
                  </div>
                  À partir de 6 € pendant 1 an
                </span>
                <span class="gap-xs flex items-center">
                  <div class="flex size-5 items-center justify-center">
                    <Icon
                      name="fa6-solid:hand-holding-heart"
                      class="text-large shrink-0"
                    />
                  </div>
                  Soutien le Réseau des agendas
                </span>
                <span class="gap-xs flex items-center">
                  <div class="flex size-5 items-center justify-center">
                    <Icon
                      name="fa6-solid:circle-nodes"
                      class="text-large shrink-0"
                    />
                  </div>
                  Disponible sur l'ensemble de nos agendas
                </span>
              </div>
            </div>
          </div>

          <img
            v-show="adlessEnd && adlessEnd >= inOneMonth"
            class="mx-xxl mt-lg"
            src="~/assets/images/illustrations/adless.svg"
            alt="Illustrations remerciement achat compte sans pub"
          />

          <div
            v-show="!adlessEnd || adlessEnd < inOneMonth"
            class="gap-xl flex flex-wrap"
          >
            <div
              class="px-sm pt-xxl pb-lg border-sm flex grow flex-col items-center rounded-sm border-gray-300"
            >
              <span class="mb-sm mt-1.25 text-2xl font-bold">1 an</span>
              <span class="mb-lg font-josefin text-5xl font-bold text-blue-500"
                >6 €</span
              >

              <GButton class="w-31.25" @click="onSubmit('adless_12')">
                <template v-if="loading === 'adless_12'" #icon>
                  <GSpinner
                /></template>
                <template v-else #default> Sélectionner </template>
              </GButton>
            </div>

            <div
              class="px-sm pt-xxl pb-lg border-md relative flex grow flex-col items-center rounded-sm border-blue-500 bg-blue-50"
            >
              <span
                class="px-xs rounded-xxs border-sm absolute top-[12px] -right-1.5 border-blue-400 bg-white font-semibold text-blue-500"
                >Économisez 2 €</span
              >

              <span class="mb-sm mt-1.25 text-2xl font-bold">2 ans</span>
              <span class="mb-lg font-josefin text-5xl font-bold text-blue-500"
                >10 €</span
              >

              <GButton class="w-31.25" @click="onSubmit('adless_24')">
                <template v-if="loading === 'adless_24'" #icon>
                  <GSpinner />
                </template>
                <template v-else #default> Sélectionner </template>
              </GButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AppDialog
      ref="dialog"
      aria-label="Compte sans pub"
      class="p-lg dialog-center gap-md min-w-form max-[530px]:min-w-[90vw]"
      @click-out="dialog?.close"
    >
      <header class="flex items-center justify-between">
        <h2 class="text-nowrap">Compte sans pub</h2>
        <form method="dialog">
          <GButton
            data-style="text"
            data-size="large"
            type="submit"
            aria-label="Fermer"
          >
            <template #icon>
              <Icon name="fa6-solid:xmark" />
            </template>
          </GButton>
        </form>
      </header>

      <section class="gap-md flex flex-col">
        <div
          class="gap-md mt-xs mb-md bg-info text-bg-info px-lg py-md flex items-center rounded-sm"
        >
          <Icon name="fa6-solid:circle-info" class="flex-none" />
          <p>Vous devez être connecté pour continuer</p>
        </div>
      </section>

      <footer class="flex justify-center">
        <GLink
          data-role="button"
          to="authentification"
          @click="sessionStorage.set('redirect', '/sans-pub')"
          >Connexion / Inscription</GLink
        >
      </footer>
    </AppDialog>

    <AppDialog
      ref="dialogError"
      aria-label="Commande impossible"
      class="dialog-center p-lg content:[--dialog-width:var(--breakpoint-form)] [--dialog-width:80vw]"
      @click-out="dialogError?.close"
    >
      <header class="mb-md flex items-center justify-between">
        <h2 class="gap-xs flex items-center">Commande impossible</h2>
        <form method="dialog">
          <GButton
            data-style="text"
            data-size="large"
            type="submit"
            aria-label="Fermer"
          >
            <template #icon>
              <Icon name="fa6-solid:xmark" />
            </template>
          </GButton>
        </form>
      </header>

      <section>
        <div
          class="gap-md mb-sm bg-warning px-lg py-md text-bg-warning flex items-center rounded-sm"
        >
          <Icon name="fa6-solid:circle-xmark" class="text-large flex-none" />

          <p>Vous avez déjà un paiement en attente.</p>
        </div>
        <div class="flex justify-end">
          <GButton @click="dialogError.close()">Fermer</GButton>
        </div>
      </section>
    </AppDialog>
  </div>
</template>

<script setup>
definePageMeta({
  header: "default",
  footer: "default",
});

const sessionStorage = useSessionStorage();
const authStore = useAuthStore();
const tokenStore = useTokenStore();

const fetchApi = useFetchApi();

const { data: user } = await useFetchUser();

const dialog = useTemplateRef("dialog");
const dialogError = useTemplateRef("dialogError");

const loading = ref(null);

const inOneMonth = new Date();
inOneMonth.setMonth(inOneMonth.getMonth() + 1);

const adlessEnd = computed(() =>
  user.value?.serviceType ? new Date(user.value.serviceEnd) : null,
);

const originInfo = computed(() => {
  const origin = sessionStorage.get("origin") ?? unref(useCookie("origin"));
  if (!origin) {
    return null;
  }

  const input = new URL(origin.url);

  if (authStore.isControlled) {
    input.searchParams.append("access_token", tokenStore.access.token);
    input.searchParams.append(
      "access_expire",
      useTimestampToUnix(tokenStore.access.exp),
    );
  }

  return {
    url: input.href,
    label: input.host,
  };
});

function onSubmit(service) {
  if (!authStore.isControlled) {
    dialog.value?.showModal();
    return;
  }

  if (loading.value) {
    return;
  }
  loading.value = service;

  fetchApi
    .post("/v1/adless", { service })
    .then(async ({ body }) => {
      return navigateTo(body.url, {
        external: true,
      });
    })
    .catch((e) => {
      if (e.status === 403 && e.data.error === "pending") {
        dialogError.value?.showModal();
      }
    })
    .finally(() => {
      loading.value = null;
    });
}
</script>
